class BrandPage extends HTMLElement {
  constructor() {
    super();
    this.lettersSections = Array.from(this.querySelectorAll('.all-brands .all-brands__section'));
    this.vendorList = this.querySelectorAll('.brand-list__carousel .item');
    this.init();
  }

  hideSections() {
    const arrayVendorsAvailable = this.lettersSections
      .filter(section => section.querySelector('ul')?.children.length > 0)
      .map(section => {
        section.classList.remove('hide');
        return { id: section.getAttribute('id'), element: section };
      });

    return arrayVendorsAvailable;
  }

  hideLetters(arrayVendorsAvailable) {
    let visibleVendor = []
    this.vendorList.forEach(letter => {
      const dataAnchor = letter.getAttribute('data-anchor');
      if (arrayVendorsAvailable.some(section => section.id === dataAnchor)) {
        letter.classList.remove('hide');
        visibleVendor.push(letter)
        this.scrollIntoSection(letter, arrayVendorsAvailable, dataAnchor);
      } else {
        letter.remove();
      }
    });
    if(visibleVendor.length > 0) {
      visibleVendor[0].classList.add('first')
      visibleVendor[visibleVendor.length - 1].classList.add('last')
    }
  }

  scrollIntoSection(letter, arrayVendorsAvailable, dataAnchor) {
    letter.addEventListener('click', () => {
      this.vendorList.forEach(item => item.classList.remove('active'));

      letter.classList.add('active');

      const section = arrayVendorsAvailable.find(item => item.id === dataAnchor );
      if (section) {
        const boundingRect = this.querySelector(`#${section.id}`).getBoundingClientRect();
        const headerH = this.querySelector('.brand-page__header').offsetHeight
        const x = boundingRect.left + window.scrollX;
        let y = boundingRect.top + window.scrollY - headerH;

        window.scrollTo({
          top: y,
          left: x,
          behavior: 'smooth'
        });
      }
    });
  }

  init() {
    const arrayVendorsAvailable = this.hideSections();
    this.hideLetters(arrayVendorsAvailable);
  }
}

customElements.define('brand-page', BrandPage);